import { jsx } from "react/jsx-runtime";
import StarIcon from "@mui/icons-material/Star";
import { validateTidalLicense } from "../../base/index.js";
function Star(props) {
  return /* @__PURE__ */ jsx(
    StarIcon,
    {
      "data-testid": "Star",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Star",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
Star.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "Star"
};
validateTidalLicense();
export {
  Star
};
//# sourceMappingURL=Star.js.map
